import { render } from "./TkEngagementWorkspaceHeader.vue?vue&type=template&id=ad55aaec"
import script from "./TkEngagementWorkspaceHeader.vue?vue&type=script&lang=js"
export * from "./TkEngagementWorkspaceHeader.vue?vue&type=script&lang=js"

import "./TkEngagementWorkspaceHeader.vue?vue&type=style&index=0&id=ad55aaec&lang=css"

import exportComponent from "D:\\a\\1\\s\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QAvatar,QIcon});
